// extracted by mini-css-extract-plugin
module.exports = {"grantScopesPage":"GrantScopesPage_grantScopesPage__20eYv","body":"GrantScopesPage_body__1mdbZ"};